import React from 'react';
import { CheckCircleIcon } from './icons/CheckCircleIcon';
import { XIcon } from './icons/XIcon';

interface WelcomeEmailModalProps {
    onClose: () => void;
    onContinue: () => void;
    userEmail?: string | null;
}

const WelcomeEmailModal: React.FC<WelcomeEmailModalProps> = ({ onClose, onContinue, userEmail }) => {

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center relative">
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-700"><XIcon className="w-6 h-6" /></button>
                <CheckCircleIcon className="w-16 h-16 text-green-500 mx-auto mb-4" />
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Account Created!</h2>
                <p className="text-gray-600 mb-6">A welcome email has been sent to <strong>{userEmail || 'your inbox'}</strong>. Please check your inbox to continue.</p>
                <div className="flex flex-col gap-3">
                    <button onClick={onContinue} className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-lg">
                        Proceed to Payment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WelcomeEmailModal;